import React from 'react';
import { Divider } from '@shopify/polaris';

const Placeholder = ({ height = 'auto', padding = '14px var(--p-space-200)' }) => {
    return (
        <div
            style={{
                padding: padding,
                height: height
            }}
        />
    );
};

const SpacingMarkup = () => {
    return (
        <React.Fragment>
            <Placeholder padding='5px var(--p-space-100)' height='2px'/>
            <Divider borderColor='border' borderWidth='0165' />
            <Placeholder padding='5px var(--p-space-100)' height='2px'/>
        </React.Fragment>
    );
};

export default Placeholder;
export { SpacingMarkup };